import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import Layout from '../pages/_layout/Layout';
import Footer from '../pages/_layout/Footer';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Notification from '../components/custom/Notification';

// Pages import
import Login from '../pages/login/Login';
import ForgetPassword from '../pages/login/ForgetPassword';
import Error from '../pages/error/Error';
import appRoutes from './route';

/* react router match by order of appearance in list so make sure wider match comes last, use order to control display order */

export const pagesRoutes = [
  {
    path: "/login",
    name: "Login",
    short: "Login",
    component: Login,
    icon: "sign-in",
    isPublic: true,
    inMenu: true,
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    short: "ForgetPassword",
    component: ForgetPassword,
    icon: "unlock-alt",
    isPublic: true,
    isAdhoc: true,
  },
  {
    path: "/error",
    name: "Error",
    short: "Error",
    component: Error,
    icon: "sign-in",
    isPublic: true,
    isAdhoc: true,
    
  },
  ...appRoutes,
  {
    /* this one should always come last as it matches everything or use exactMatch in the router definiton */
    redirect: true,
    path: "/",
    pathTo: "/Home",
    name: "Home"
  },
];

const ProtectedRoute = ({ component: Component, isPublic, user, ...rest }) => {
  if ((user && user.UsrId) || isPublic) {
    const from = (((rest.location || {}).state || {}).from || {}).pathname;
    if (rest.path === '/login' && from && from !== rest.path && ((user && user.UsrId))) {
      //return (<Redirect to={rest.location.state.from.pathname} />)
    }
    return (<Route {...rest} render={(props) => (<Component {...props} />)} />)
  }
  else {
    return (<Route {...rest} render={(props) => (<Redirect
      to={
        {
          pathname: '/login',
          state: { from: props.location }
        }
      } />)} />)
  }
}

class Router extends Component {
  render() {
    // const { } = this.props;
    return (
      <MainWrapper>
        <main>
          <div>
            <Layout />
            <Notification />
            <div className='container__wrap'>
              <Switch>
                {pagesRoutes
                  .map((prop, key) => {
                  if (prop.redirect) {
                    return (
                      <Redirect from={prop.path} to={prop.pathTo} key={key} />
                    );
                  }
                  return (
                    <ProtectedRoute
                      key={key}
                      path={prop.path}
                      user={this.props.user}
                      component={prop.component}
                      isPublic={prop.isPublic}
                    />
                  );
                }
                )}
              </Switch>
            </div>
            <Footer />
          </div>
        </main>
      </MainWrapper>
      
    )
  }
}

const mapStateToProps = (state) => ({
  user: (state.auth ||{}).user,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({}, dispatch)
)

// export default compose(
//   connect(
//     mapStateToProps,
//     mapDispatchToProps
//   )
// )(Router);
//  export default Router;

// export default connect(
//        mapStateToProps,
//        mapDispatchToProps
//      )(Router);


export default withRouter(connect(
  mapStateToProps, mapDispatchToProps
)(Router));



// WEBPACK FOOTER //
// ./src/app/Router.js